import {BookHeart, Plus} from 'lucide-react';
import {useTranslation} from 'react-i18next';

import {Button} from '@/components/ui/button';
import {Separator} from '@/components/ui/separator';
import {Typography} from '@/components/ui/typography';
import {cn} from '@/utils/ui';

import type {DosageDetailsWithId} from '../utils/medicationTypes';
import type {DosageDetailItemProps} from './DosageDetailItem';
import DosageDetailItem from './DosageDetailItem';

const EMPTY_DOSAGES: DosageDetailsWithId[] = [];

export type DosageInputProps = {
  value: DosageDetailsWithId[];
  onAddDosageClick?: () => void;
  onEditDosageClick?: DosageDetailItemProps['onEditClick'];
  onDeleteDosageClick?: DosageDetailItemProps['onDeleteClick'];
  error?: string;
};

const DosageInput = ({
  onAddDosageClick,
  onDeleteDosageClick,
  onEditDosageClick,
  value = EMPTY_DOSAGES,
}: DosageInputProps) => {
  const {t} = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col">
        {value.map(dosage => (
          <DosageDetailItem
            key={dosage.id}
            onDeleteClick={onDeleteDosageClick}
            onEditClick={onEditDosageClick}
            {...dosage}
          />
        ))}

        {!value.length && (
          <div className={cn('flex flex-col gap-2 border-l border-gray-600')}>
            <Separator className="w-5 translate-y-6" />
            <div className="flex flex-col gap-3 p-1 pl-7">
              <div className="flex gap-3">
                <Typography className="inline-flex items-center gap-2 text-sm">
                  <BookHeart className="text-blue-400" />
                  {t('No dosage provided')}
                </Typography>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="flex">
        <Button
          variant="link"
          size="small"
          type="button"
          onClick={onAddDosageClick}
        >
          <Plus size={12} />
          <span>{t('Add dosage')}</span>
        </Button>
      </div>
    </div>
  );
};

export default DosageInput;
